export const EVENTS_CONSTANTS = {
    SESSION_EVENTS: {
        
        SESSION_CONNECTED: 'sessionConnected',
        SESSION_DISCONNECTED: 'sessionDisconnected',
        SESSION_RECONNECTED: 'sessionReconnected',
        SESSION_RECONNECTING: 'sessionReconnecting',
        
        STREAM_CREATED: 'streamCreated',
        STREAM_DESTROYED: 'streamDestroyed',
        STREAM_PROPERTY_CHANGED: 'streamPropertyChanged',

        CONNECTION_DESTROYED: 'connectionDestroyed',
        CONNECTION_CREATED: 'connectionCreated',

        MUTE_FORCED: 'muteForced',
        MEDIA_STOPPED: 'mediaStopped',

        ARCHIVED_STARTED: 'archiveStarted',
        ARCHIVED_STOPPED: 'archiveStopped',

        HUNG_UP: 'hungUp',

        SIGNAL: {
            EMPTY: 'signal',
            HUNG_UP: 'signal:hungUp',
            MSG: 'signal:msg',
            FILE: 'signal:file',
            FILE_PDF_END: 'signal:file-pdf-end',
            FILE_IMAGE_END: 'signal:file-image-end'
        }                
    },
    PUBLISHER_EVENTS: {
        LEVEL_UPDATED: 'audioLevelUpdated'
    }
}